import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { purgeAndReconnectAction } from '../../../../redux/actions/shared.actions';
export default function ViewURLAuthentication() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useParams(), gameToken = _a.gameToken, pathing = _a.pathing;
    var userAuthorization = useSelector(function (state) { return state.userAuthorization.userSession.id; });
    var ownToken = useSelector(function (state) { return state.player.ownToken; });
    useEffect(function () {
        var redirectPath = "/onboarding/".concat(gameToken);
        if ((!pathing && userAuthorization) || (!userAuthorization && !pathing && ownToken)) {
            redirectPath = '/dashboard';
        }
        else if (pathing && userAuthorization) {
            redirectPath = '/facilitator';
        }
        dispatch(purgeAndReconnectAction(gameToken)).then(function () {
            navigate(redirectPath);
        });
    }, [gameToken, pathing, userAuthorization, ownToken]);
    return null;
}
